(() => {
  const fullMenuQuery = window.matchMedia('(min-width: 750px)');
  let headerObserver;
  let resizeFrame;

  const showEveryCategory = (overflowList, attempt = 0) => {
    if (!overflowList || !fullMenuQuery.matches) return;

    try {
      if (typeof overflowList.showAll === 'function') {
        overflowList.showAll();

        const list = overflowList.shadowRoot?.querySelector('[part="list"]');
        const moreSlot = overflowList.shadowRoot?.querySelector('slot[name="more"]');

        if (list instanceof HTMLElement) {
          list.style.setProperty('flex-wrap', 'nowrap', 'important');
          list.style.setProperty('overflow-x', 'auto', 'important');
          list.style.setProperty('overflow-y', 'hidden', 'important');
        }

        if (moreSlot instanceof HTMLSlotElement) {
          moreSlot.hidden = true;
        }
        return;
      }
    } catch (error) {
      // The custom element may be defined before its internal references finish initializing.
    }

    if (attempt < 40) {
      window.setTimeout(() => showEveryCategory(overflowList, attempt + 1), 50);
    }
  };

  const applyHeaderMode = () => {
    const header = document.querySelector('#header-component');
    if (!(header instanceof HTMLElement)) return;

    if (fullMenuQuery.matches) {
      if (header.dataset.menuStyle !== 'menu') {
        header.dataset.menuStyle = 'menu';
      }

      const overflowList = header.querySelector('overflow-list');
      if (overflowList) {
        customElements.whenDefined('overflow-list').then(() => showEveryCategory(overflowList));
      }
    } else if (header.dataset.menuStyle !== 'drawer') {
      header.dataset.menuStyle = 'drawer';
    }
  };

  const observeHeader = () => {
    const header = document.querySelector('#header-component');
    if (!(header instanceof HTMLElement)) {
      window.setTimeout(observeHeader, 50);
      return;
    }

    headerObserver?.disconnect();
    headerObserver = new MutationObserver(() => {
      if (fullMenuQuery.matches && header.dataset.menuStyle !== 'menu') {
        header.dataset.menuStyle = 'menu';
      }
    });
    headerObserver.observe(header, {
      attributes: true,
      attributeFilter: ['data-menu-style'],
    });

    applyHeaderMode();
  };

  const scheduleApply = () => {
    if (resizeFrame) cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      resizeFrame = undefined;
      applyHeaderMode();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeHeader, { once: true });
  } else {
    observeHeader();
  }

  fullMenuQuery.addEventListener('change', scheduleApply);
  window.addEventListener('resize', scheduleApply, { passive: true });
  document.addEventListener('shopify:section:load', observeHeader);
})();

(() => {
  const isHomePage = () => {
    return document.documentElement.classList.contains('ary-real-home') ||
      Boolean(document.querySelector('main[data-template="index"]'));
  };

  const updateHomeMobileMessage = () => {
    const title = document.querySelector('.ary-real .ary-mobile-contact-row .ary-mobile-contact:first-child strong');
    if (title) title.textContent = 'Candy question?';
  };

  const removeOldProductMessages = () => {
    document.querySelectorAll('.ary-product-contact-row').forEach((row) => row.remove());
  };

  const addHeaderMessages = () => {
    const existing = document.querySelector('.ary-global-service-messages');

    if (isHomePage()) {
      existing?.remove();
      return;
    }

    if (existing) return;

    const topRow = document.querySelector('#header-component .header__row--top');
    if (!(topRow instanceof HTMLElement)) return;

    const messages = document.createElement('div');
    messages.className = 'ary-global-service-messages';
    messages.setAttribute('aria-label', 'Contact and delivery information');
    messages.innerHTML = `
      <div class="ary-global-service-message">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3h4l2 5-2.5 1.6a15 15 0 0 0 5.9 5.9L16 13l5 2v4c0 1.1-.9 2-2 2C10.2 21 3 13.8 3 5c0-1.1.9-2 2-2Z"></path></svg>
        <span><strong>Candy question?</strong><small>We have sweet answers! 1-(844)-28-CANDY</small></span>
      </div>
      <div class="ary-global-service-message">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.5 5.5L20 9l-4 4 .9 5.7L12 16l-4.9 2.7L8 13 4 9l5.5-.5L12 3Z"></path></svg>
        <span><strong>Same-Day Delivery</strong><small>Raleigh, NC &amp; nearby areas</small></span>
      </div>`;

    topRow.appendChild(messages);
  };

  const applyServiceMessages = () => {
    updateHomeMobileMessage();
    removeOldProductMessages();
    addHeaderMessages();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyServiceMessages, { once: true });
  } else {
    applyServiceMessages();
  }

  window.setTimeout(applyServiceMessages, 100);
  document.addEventListener('shopify:section:load', () => window.setTimeout(applyServiceMessages, 0));
})();

// Aryellys: keep the app's live sold-count logic/design, but shorten its wording on product pages.
(() => {
  const phrase = /\bbags sold recently\b/gi;

  const replaceTextNode = (node) => {
    if (!(node instanceof Text) || !phrase.test(node.nodeValue || '')) return;
    phrase.lastIndex = 0;
    node.nodeValue = node.nodeValue.replace(phrase, 'sold recently');
  };

  const scan = (root) => {
    if (!root) return;

    if (root instanceof Text) {
      replaceTextNode(root);
      return;
    }

    if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, textarea, noscript')) return NodeFilter.FILTER_REJECT;
        phrase.lastIndex = 0;
        return phrase.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    const matches = [];
    while (walker.nextNode()) matches.push(walker.currentNode);
    matches.forEach(replaceTextNode);
  };

  const start = () => {
    if (!document.querySelector("main[data-template^='product']")) return;

    scan(document.body);

    new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'characterData') {
          replaceTextNode(record.target);
          continue;
        }
        record.addedNodes.forEach(scan);
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
